const error404 = {
    title: 'Erreur 404 - Page Introuvable',
    header: 'Page Introuvable',
    message: "La page que vous cherchez n'existe pas.",
    link: 'Accueil',
}

export default error404
